import Work1 from '../../assets/movie_world.png';
import Work2 from '../../assets/portfolio.png';
import Work3 from '../../assets/weather__app.png';
import Work4 from '../../assets/notes_taking_website.png';
import Work5 from '../../assets/work1.jpg';
import Work6 from '../../assets/qr-code-2.png';
import Work7 from '../../assets/speech_to_text_convertor.png';
import Work8 from '../../assets/cli.jpg';
import Work9 from '../../assets/quote.png';
import Work10 from '../../assets/trexo.png';
import Work11 from '../../assets/zoom.png';
import Work12 from '../../assets/web scrapper.png';

export const projectsData = [
    {
        id:1,
        image: Work1,
        title: 'Movie World',
        category: 'API Based',
        demoLink: 'https://movie-world-by-yash.netlify.app/',
        github: 'https://github.com/THEYASHGAUR/Movie-World'
    },
    {
        id:2,
        image: Work2,
        title: 'Portfolio Website',
        category: 'Frontend',
        demoLink: '',
        github: 'https://github.com/THEYASHGAUR/ReactJS-Portfolio'
    },
    {
        id:3,
        image: Work3,
        title: 'Weather App',
        category: 'API Based',
        demoLink: 'https://weather-app-new-six.vercel.app/',
        github: 'https://github.com/THEYASHGAUR/Weather-App'
    },
    {
        id:4,
        image: Work4,
        title: 'Notes Taking Website ',
        category: 'Frontend',
        demoLink: 'https://notes-taking-application.netlify.app/',
        github: 'https://github.com/THEYASHGAUR/Notes-taking-Website'
    },
    {
        id:5,
        image: Work5,
        title: 'Dall-e Clone',
        category: 'Full Stack',
        demoLink: 'https://dall-e-clonee.netlify.app',
        github:'https://github.com/THEYASHGAUR/Dall-e-Clone'
    },
    {
        id:6,
        image: Work6,
        title: 'QR Code Generator',
        category: 'API Based',
        demoLink: 'https://qr-code-generator-by-yash-gaur.netlify.app/',
        github:'https://github.com/THEYASHGAUR/QR-Code-Generator'
    },
    {
        id:7,
        image: Work7,
        title: 'Speech to Text Convertor',
        category: 'Frontend',
        demoLink: 'https://speech-to-text-convertor-yg.netlify.app/',
        github:'https://github.com/THEYASHGAUR/Speech-to-text-Convertor'
    },
    {
        id:8,
        image: Work8,
        title: 'CLI Tool for QR Code Generator',
        category: 'Backend',
        demoLink: '#',
        github: 'https://github.com/THEYASHGAUR/qr-code-generator-cli-hackathon'
    },
    {
        id:9,
        image: Work9,
        title: 'Random Quotes Generator',
        category: 'API Based',
        demoLink: 'https://random-quote-generator-yg.netlify.app/',
        github: 'https://github.com/THEYASHGAUR/Random-Quote-Generator'
    },
    {
        id:10,
        image: Work10,
        title: 'E-Commerce With Admin Panel',
        category: 'Full Stack',
        demoLink: 'https://trexo-one.vercel.app/',
        github: 'https://github.com/THEYASHGAUR/Trexo'
    },
    {
        id:11,
        image: Work11,
        title: 'Zoom Clone',
        category: 'Full Stack',
        demoLink: 'https://zoom-clone-tau-livid.vercel.app',
        github: 'https://github.com/THEYASHGAUR/zoom-clone'
    },
    {
        id:12,
        image: Work12,
        title: 'Web Scrapper',
        category: 'Full Stack',
        demoLink: 'https://web-scrapper-fawn.vercel.app/',
        github: 'https://github.com/THEYASHGAUR/MERN-Web-Scrapper'
    }
    
]

export const ProjectsNav = [
    {
        name : 'All',
    },
    {
        name:'API Based',
    },
    {
        name : 'Frontend',
    },
    {
        name : 'Backend',
    },
    {
        name : 'Full Stack',
    }
    

]